import React, { type ReactNode } from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap, cx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import Spinner from '@atlaskit/spinner';
import { token } from '@atlaskit/tokens';
import { ButtonMenuItem } from '@atlassian/navigation-system/side-nav-items/button-menu-item';

import { messages } from './messages';

type MenuLoadingItemProps = {
	icon: ReactNode;
	label: ReactNode;
};

const styles = cssMap({
	iconsBlock: {
		paddingInline: token('space.075'),
	},
});

export const MenuLoadingItem = ({ icon, label }: MenuLoadingItemProps) => {
	const { formatMessage } = useIntl();
	return (
		<ButtonMenuItem
			elemBefore={icon}
			elemAfter={
				<Box xcss={cx(styles.iconsBlock)}>
					<Spinner size="small" />
				</Box>
			}
			testId="menu-button-loading"
		>
			{label}
			<span aria-label={formatMessage(messages.loadingItemAriaLabel)} />
		</ButtonMenuItem>
	);
};
